import React from 'react'
import Divider from "../components/Divider"
import Helmet from 'react-helmet'

import image_bg5 from '../images/bg5.png'
import image_bg6 from '../images/bg6.png'
import image_camera from '../images/camera.png'
import image_camera2 from '../images/camera2.png'
import image_chart from '../images/chart.svg'
import image_circleIcon from '../images/circle-icon.svg'
import image_computer3 from '../images/computer3.png'
import image_control from '../images/control.png'
import image_cursor from '../images/cursor.png'
import image_emp from '../images/emp-detail.png'
import image_enterprise from '../images/enterprise-logo.png'
import image_eyeIcon from '../images/eye-icon.svg'
import image_fire from '../images/fire.png'
import image_fire2 from '../images/fire2.png'
import image_ibeacon from '../images/ibeacon.png'
import image_ibeacon2 from '../images/ibeacon2.png'
import image_ibeacon3 from '../images/ibeacon3.png'
import image_iphone4 from '../images/iphone4.png'
import image_mapLayers from '../images/map-layers.png'
import image_mark from '../images/mark-pin.png'
import image_outter from '../images/outter-eye.svg'
import image_persons from '../images/persons.svg'
import image_security from '../images/security.svg'
import image_sensor from '../images/sensor.png'
import image_sensor2 from '../images/sensor2.png'
import image_smoke from '../images/smoke.png'
import image_smoke2 from '../images/smoke2.png'
import image_sprinkler from '../images/sprinkler.png'
import image_sprinkler2 from '../images/sprinkler2.png'
import image_sprinkler3 from '../images/sprinkler3.png'
import image_sprinkler4 from '../images/sprinkler4.png'
import image_temp from '../images/temp.png'
import image_timeIcon from '../images/time-icon.svg'
import image_track from '../images/track.png'
import image_wifiLG from '../images/wifi-lg.png'
import image_wifi from '../images/wifi.png'
import image_wifi2 from '../images/wifi2.png'

const locusEnterprisePage = () => (
  <main id="main" role="main" style={{ marginTop: '134px' }}>
    <Helmet title="LocusEnterprise - visualize and manage your enterprise assets"/>
    <section className="promo viewport-section" style={{boxShadow: "0 22px 42px rgba(20,52,92,.1)"}}>
      <div className="bg-stretch">
        <span data-srcset={image_bg5} />
      </div>
      <div className="inner-container">
        <div className="description">
          <div className="align">
            <div className="logo-icon">
              <img
                src={image_enterprise}
                alt=""
                width="257"
                height="54"
              />
            </div>
            <h1>
              Enables enterprises to <br />manage and visualize <br />their assets.
            </h1>
            <div className="text">
              <p>
                A unified location-based application framework that enables
                enterprise users to track, manage and visualize all their assets
                - people, places and things.
              </p>
            </div>
          </div>
        </div>
        <div className="tag-wrap">
          <i className="tag-icon control">
            <a href="#">
              <img
                src={image_control}
                width="112"
                height="65"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon wifi wifi4">
            <a href="#">
              <img
                src={image_wifiLG}
                width="73"
                height="52"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon wifi wifi5">
            <a href="#">
              <img
                src={image_wifi}
                width="67"
                height="50"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon wifi wifi2">
            <a href="#">
              <img
                src={image_wifi2}
                width="73"
                height="54"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon wifi wifi3">
            <a href="#">
              <img
                src={image_wifi2}
                width="80"
                height="59"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon temp temp1">
            <a href="#">
              <img
                src={image_temp}
                width="116"
                height="52"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon temp temp2">
            <a href="#">
              <img
                src={image_temp}
                width="116"
                height="52"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon fire fire2">
            <a href="#">
              <img
                src={image_fire2}
                width="124"
                height="48"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon sprinkler sprinkler1">
            <a href="#">
              <img
                src={image_sprinkler}
                width="75"
                height="43"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon sprinkler sprinkler2">
            <a href="#">
              <img
                src={image_sprinkler2}
                width="93"
                height="53"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon fire fire1">
            <a href="#">
              <img
                src={image_fire}
                width="140"
                height="54"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon ibeacon ibeacon3">
            <a href="#">
              <img
                src={image_ibeacon3}
                width="90"
                height="52"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon sprinkler sprinkler4">
            <a href="#">
              <img
                src={image_sprinkler4}
                width="101"
                height="57"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon ibeacon ibeacon1">
            <a href="#">
              <img
                src={image_ibeacon}
                width="101"
                height="60"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon ibeacon ibeacon2">
            <a href="#">
              <img
                src={image_ibeacon2}
                width="73"
                height="43"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon sprinkler sprinkler5">
            <a href="#">
              <img
                src={image_sprinkler}
                width="86"
                height="48"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon sensor sensor1">
            <a href="#">
              <img
                src={image_sensor}
                width="133"
                height="56"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon sensor sensor2">
            <a href="#">
              <img
                src={image_sensor2}
                width="137"
                height="58"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon smoke smoke1">
            <a href="#">
              <img
                src={image_smoke}
                width="109"
                height="50"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon smoke smoke2">
            <a href="#">
              <img
                src={image_smoke2}
                width="94"
                height="42"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon camera camera2">
            <a href="#">
              <img
                src={image_camera2}
                width="128"
                height="49"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon camera camera1">
            <a href="#">
              <img
                src={image_camera}
                width="119"
                height="45"
                alt="image description"
              />
            </a>
          </i>
          <i className="tag-icon sprinkler sprinkler3">
            <a href="#">
              <img
                src={image_sprinkler3}
                width="71"
                height="41"
                alt="image description"
              />
            </a>
          </i>
        </div>
      </div>
    </section>
    <section className="center-sm-block">
      <div className="detail">
        <h2 data-bottom="opacity: 0;" data-center-top="opacity: 1;">
          Simplified approach to enterprise location-based applications
        </h2>
        <div data-bottom="opacity: 0;" data-center-top="opacity: 1;">
          <p>
            LocusEnterprise is a completely new approach to traditional location
            and spatial applications that are unwieldy and expensive to deploy.
          </p>
          <p>
            LocusEnterprise is a customizable solution which incorporates asset
            tracking and location intelligence into your business applications
            and processes.
          </p>
        </div>
      </div>
    </section>
    <section className="tracking-location">
      <Divider />
      <div className="container">
        <div
          className="detail"
          data-bottom="opacity: 0;"
          data-center-top="opacity: 1;"
        >
          <i className="icon-wrap">
            <img
              src={image_timeIcon}
              alt="image description"
              width="57"
              height="58"
            />
          </i>
          <h2>
            Real-Time <br />Location Tracking
          </h2>
          <p>
            At-a-glance dashboard and APIs give you and your applications
            immediate situational awareness of your resources across facilities.
          </p>
        </div>
        <div className="img-holder">
          <div className="track-image">
            <img
              src={image_track}
              alt="image description"
              width="675"
              height="655"
            />
            <div className="mark-pin">
              <img
                src={image_mark}
                alt="image description"
                width="38"
                height="54"
              />
            </div>
            <div className="mark-pin pin2">
              <img
                src={image_mark}
                alt="image description"
                width="38"
                height="54"
              />
            </div>
            <div
              className="mark-pin pin3"
              data-bottom-top="transform: scale(1);"
              data-center-bottom="transform: scale(1.5);"
            >
              <img
                src={image_mark}
                alt="image description"
                width="38"
                height="54"
              />
            </div>
            <div
              className="emp-detail"
              data-center-top="transform: scale(0);"
              data-center="transform: scale(1);"
            >
              <img
                src={image_emp}
                alt="image description"
                width="175"
                height="208"
              />
            </div>
            <div
              className="cursor"
              data-bottom="transform:translatex(-100px);"
              data-center-top="transform:translatex(0px);"
            >
              <img
                src={image_cursor}
                alt="image description"
                width="71"
                height="75"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="historical-location">
      <Divider />
      <div className="container">
        <div
          className="img-holder"
          data-bottom-top="transform: scale(0.3) rotate(-25deg) translate(-800px, -200px);"
          data-center-top="transform: scale(1) rotate(0deg) translate(0px, 0px);"
        >
          <div className="iphone">
            <img
              src={image_iphone4}
              alt="image description"
              width="548"
              height="1006"
            />
          </div>
        </div>
        <div
          className="detail"
          data-bottom-top="opacity: 0;"
          data-center-top="opacity: 1;"
        >
          <i className="icon-wrap">
            <img
              src={image_timeIcon}
              alt="image description"
              width="57"
              height="58"
            />
          </i>
          <h2>
            Real-Time &amp; Historical <br />Location Data
          </h2>
          <p>
            Locus Enterprise offers location data lakes to provide a secure
            repository for historical location data. Utilize our powerful API
            queries and custom reports across space and time to enable key
            historical insights.
          </p>
        </div>
      </div>
    </section>
    <section className="management-info container">
      <Divider />
      <div className="detail">
        <div data-bottom="opacity: 0;" data-center-top="opacity: 1;">
          <h2>IoT, Sensor Data Visualization &amp; Management</h2>
          <p>
            Every Internet of Things (IoT) device has a location. Access and
            visualize location <br />information from these data-generating
            devices at enterprise scale.
          </p>
        </div>
        <ul className="icon-list">
          <li
            data-bottom-top="transform: scale(0) translatey(200px); opacity:0;"
            data--100-bottom="transform: scale(1) translatey(0px); opacity: 1;"
          >
            <a href="#">
              <img
                src={image_chart}
                width="62"
                height="62"
                alt="imag description"
              />
            </a>
          </li>
          <li
            data-bottom-top="transform: scale(0) translatey(300px); opacity:0;"
            data--150-bottom="transform: scale(1) translatey(0px); opacity: 1;"
          >
            <a href="#">
              <img
                src={image_outter}
                width="62"
                height="62"
                alt="imag description"
              />
            </a>
          </li>
          <li
            data-bottom-top="transform: scale(0) translatey(400px); opacity:0;"
            data--200-bottom="transform: scale(1) translatey(0px); opacity: 1;"
          >
            <a href="#">
              <img
                src={image_persons}
                width="62"
                height="62"
                alt="imag description"
              />
            </a>
          </li>
          <li
            data-bottom-top="transform: scale(0) translatey(500px); opacity:0;"
            data--250-bottom="transform: scale(1) translatey(0px); opacity: 1;"
          >
            <a href="#">
              <img
                src={image_security}
                width="62"
                height="62"
                alt="imag description"
              />
            </a>
          </li>
        </ul>
      </div>
      <div
        className="img-holder"
        data-bottom-top="transform: translatey(300px);"
        data-center-top="transform: translatey(0px);"
      >
        <img
          src={image_computer3}
          alt="image description"
          width="1131"
          height="704"
        />
      </div>
    </section>
    <section className="access-info">
      <Divider />
      <div className="parallax-bg">
        <img src={image_bg6} alt="image description" />
      </div>
      <div className="container">
        <div
          className="detail"
          data-bottom="opacity: 0;"
          data-center-top="opacity: 1;"
        >
          <i className="icon-wrap">
            <img
              src={image_eyeIcon}
              alt="image description"
              width="62"
              height="37"
            />
          </i>
          <h2>Access Control</h2>
          <p>
            Take collaboration of your location data to another level within
            your enterprise. Share private map layers and asset classes with
            specific groups within their applications allowing complete control
            over your location data.{' '}
          </p>
        </div>
        <div className="img-holder">
          <div className="map-layers">
            <img
              src={image_mapLayers}
              alt="image description"
              width="510"
              height="807"
            />
          </div>
        </div>
      </div>
    </section>
  </main>
)

export default locusEnterprisePage



// WEBPACK FOOTER //
// ./src/pages/LocusEnterprise.js